<template>
  <el-dialog :destroy-on-close="true" :visible.sync="dialogVisible" width="20%" :before-close="close">
    <div slot="title" class="title">{{disabled == false?'添加周边':'修改周边'}}</div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="周边名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="所属父级" prop="pid">
          <el-select
            style="width: 100%"
            v-model="ruleForm.pid"
            placeholder="请选择父级"
          >
            <el-option :label="v.title" :value="v.pid" v-for="(v,k) in arr" :key="k"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="small-btn btn-bor" size="small" @click="close"
        >取 消</el-button
      >
      <el-button
        class="small-btn bgC"
        size="small"
        type="primary"
        @click="submitForm('ruleForm')"
        >{{disabled == false?'确 定':'修 改'}}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
	  disabled: {
	    type: Boolean,
	    default() {
	      return false;
	    },
	  },
	arr:{
		type:Array,
		default:[]
	},
	accountObj:{
		type:Object,
		default(){
			return {}
		}
	}
  },
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        pid: "",
		name:"",
      },
      rules: {
        name: [{ required: true, message: "请输入周边名称", trigger: "blur" }],
        pid: [{ required: true, message: "请选择父级", trigger: "blur" }],
      },
    };
  },
  methods: {
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			this.$emit('onPeriphery',this.ruleForm)
        } else {
          this.$message.error("请输入必填项！");
          return false;
        }
      });
    },
    //   关闭弹框
    close() {
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.title {
  text-align: left;
}
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 0 !important;
  padding: 5px 30px;
}
.el-dialog__body {
  padding-top: 10px;
}
.el-dialog {
  border-radius: 8px;
}
.el-dialog__footer {
  padding-top: 0;
  text-align: center;
}
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>